'use strict';

import type { Language } from '../../Utilities/Languages';
import { Entity } from '../Entity';

export class IndPrefLang extends Entity {
  protected prefLang: Language;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.prefLang = data.prefLang;
  }

  public getIndPrefLang(): Language {
    return this.prefLang;
  }
}
